import forBasicControl from "./forBasicControl";
import { IControlProps, IInputControl, IBasicControlDefinition, IRadioControl, IFormControlDefinition } from "./types";
import { FormGroup, Input, FormFeedback, Label, InputGroup } from "reactstrap";
import React from "react";
import LabelWithToolTip from "../LabelWithToolTip";

export function createLabel(definition: IFormControlDefinition<IBasicControlDefinition>, placeholder: boolean = false, label?: string): string {
    if (definition.required)
        if (placeholder)
            return `${label || definition.config.label} *`;
        else
            return `${label || definition.config.label} (verplicht)`;
    else
        return label || definition.config.label;
}

export const BasicInputControl = forBasicControl((props: IControlProps<string, IInputControl>) => {
    return <>
        <FormGroup>
            <LabelWithToolTip
                label={createLabel(props.definition, true)}
                field={props.definition.key}
                tooltip={props.definition.config.description} />

            <Input
                aria-label={createLabel(props.definition)}
                id={props.definition.key}
                invalid={props.showValidation && !props.isValid}
                onBlur={() => props.onBlur()}
                onChange={(evt) => props.onChange(evt.target.value)}
                placeholder={createLabel(props.definition, true)}
                readOnly={props.readOnly}
                title={props.definition.config.description || createLabel(props.definition)}
                type={props.definition.config.controlType}
                valid={props.showValidation && props.isValid}
                value={props.value || ''}
            />

            {!props.isValid && <FormFeedback valid={false}>{props.validationMessage}</FormFeedback>}
        </FormGroup>
    </>
});
export interface ICheckBoxControlDefintion extends IBasicControlDefinition {
    customLabel: JSX.Element;
}
export const CheckOrRadio = forBasicControl((props: IControlProps<boolean, ICheckBoxControlDefintion>) => <FormGroup>
    <div className={"custom-control custom-checkbox " + (!props.isValid ? 'is-invalid' : '')}
        onClick={() => !props.readOnly && props.onChange(!(props.value || false))}>
        <Input
            aria-label={createLabel(props.definition)}
            checked={props.value || false}
            className="custom-control-input"
            invalid={props.showValidation && !props.isValid}
            name={props.definition.key}
            onChange={(evt) => props.onChange(evt.currentTarget.checked, false)}
            placeholder={createLabel(props.definition, true)}
            disabled={props.readOnly}
            readOnly={props.readOnly}
            title={createLabel(props.definition)}
            type='checkbox'
            valid={props.showValidation && props.isValid}
        />
        {props.definition.config.customLabel
            ? <Label className="custom-control-label" for={props.definition.key}>{props.definition.config.customLabel}</Label>
            : <LabelWithToolTip field={props.definition.key} label={props.definition.config.label} tooltip={props.definition.config.description} className="custom-control-label" />
        }
    </div>

    {!props.isValid && <FormFeedback valid={false}>{props.validationMessage}</FormFeedback>}
</FormGroup>);

export const RadioGroup = forBasicControl((props: IControlProps<string | number | boolean, IRadioControl>) => <FormGroup>
    <InputGroup className={(props.showValidation && !props.isValid) ? "is-invalid" : ""} title={createLabel(props.definition)}>
        <div className="title-radio-button">{createLabel(props.definition, true)}</div>
        {props.definition.config.options.map((item) =>
            <Label
                key={item.value}
                aria-label={item.label}
                title={item.label}>
                {item.label}
                <div className="form-check form-check-inline">
                    <Input
                        checked={(props.value || props.value === 0 || props.value === false) && props.value === item.value}
                        invalid={props.showValidation && !props.isValid}
                        onChange={() => props.onChange(item.value, true)}
                        readOnly={props.readOnly}
                        type="radio"
                        valid={props.showValidation && props.isValid}
                    />
                </div>
            </Label>)}
    </InputGroup>
    {!props.isValid && <FormFeedback valid={false} >{props.validationMessage}</FormFeedback>}
</FormGroup>);
